<template>
  <div id="wrapper">
    <contract-side-bar index="1" />
    <div id="content-wrapper" class="page">
      <div class="container-fluid">
        <a href="#" @click.prevent="goBack">
          <i class="fas fa-arrow-left"></i>
          Back
          <!-- Quay lại -->
        </a>
        <b-card class="mt-3">
          <b-tabs content-class="mt-3" v-model="tabIndex">
            <b-tab title="Detail">
              <form @submit.prevent="submitItem" autocomplete="off">
                <b-row class="mb-4">
                  <b-col cols>
                    <b>
                      Contract information
                      <!-- Thông tin hợp đồng -->
                    </b>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Project
                      <!-- Tên dự án -->
                    </label>
                    <code>*</code>
                  </b-col>
                  <b-col cols="9">
                    <b-form-input v-model="item.tieude" required></b-form-input>
                  </b-col>
                  <b-col>
                    <button class="btn btn-primary mb-3" type="submit">
                      Update
                      <!-- Cập nhật -->
                    </button>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Contract ID
                      <!-- Số hợp đồng -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input v-model="item.sohopdong"></b-form-input>
                  </b-col>
                  <b-col cols="1"></b-col>
                  <b-col cols="2">
                    <label class="mr-2">
                      Status
                      <!-- Trạng thái -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-select
                      v-model="item.tinhtrang"
                      :options="optionsTinhTrang"
                      value-field="id"
                      text-field="pickListValue"
                      disabled
                    ></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Contract Type
                      <!-- Loại hình -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-select id="loaihinhhopdong"
                      v-model="item.loaihinhhopdong"
                      :options="optionsLoaihinhhopdong"
                      value-field="id"
                      text-field="pickListValue">
                    </b-form-select>
                  </b-col>
                  <b-col cols="1"></b-col>
                  <b-col cols="2">
                    <label class="mr-2">
                      Scope of work
                      <!-- Phạm vi công việc -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input v-model="item.phamvicongviec"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Department
                      <!-- Phòng ban -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-select v-model="item.departmentid"
                      :options="departments"
                      value-field="id"
                      text-field="tendonvi"
                      required>
                    </b-form-select>
                  </b-col>
                  <b-col cols="1"></b-col>
                  <b-col cols="2">
                    <label class="mr-2">
                      Contract signing date
                      <!-- Ngày ký hợp đồng -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <vue-datepicker-local style="width: 100%"
                      v-model="item.ngayky"
                      :local="local"
                      clearable
                      format="DD/MM/YYYY"/>
                  </b-col>
                </b-row>
                <br/><br/>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Contract Value
                      <!-- Giá trị hợp đồng -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <my-currency-input v-model="item.giatrihopdong" />
                  </b-col>
                  <b-col cols="1"></b-col>
                  <!-- @Edit Thanh hide -->
                  <!-- <b-col cols="2">
                    <label class="mr-2">Giá trị nghiệm thu</label>
                  </b-col>
                  <b-col cols="3">
                    <my-currency-input v-model="item.giatriduocnghiemthu" />
                  </b-col> -->
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Exclusivity
                      <!-- Đặc điểm -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-select id="dacdiem"
                      v-model="item.dacdiem"
                      :options="optionsDacdiem"
                      value-field="id"
                      text-field="pickListValue">
                    </b-form-select>
                  </b-col>
                  <b-col cols="1"></b-col>
                  <b-col cols="2">
                    <label class="mr-2">
                      First broadcast date
                      <!-- Ngày phát sóng đầu tiên -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <vue-datepicker-local style="width: 100%"
                      v-model="item.ngayphatsong"
                      :local="local"
                      clearable
                      format="DD/MM/YYYY"
                    />
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Period by use
                      <!-- Thời hạn sử dụng -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-textarea v-model="item.thoigiansudung" rows="3" max-rows="6"></b-form-textarea>
                  </b-col>
                  <b-col cols="1"></b-col>
                  <b-col cols="2">
                    <label class="mr-2">
                      Channel is being used
                      <!-- Kênh được sử dụng -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-textarea v-model="item.kenhduocsudung" rows="3" max-rows="6"></b-form-textarea>
                  </b-col>
                </b-row>
                <br/><br/>
                <!-- @Edit Thanh hide -->
                <!-- <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">Ngày hiệu lực</label>
                  </b-col>
                  <b-col cols="3">
                    <my-date-picker v-model="ngayhieuluc_selected"></my-date-picker>
                  </b-col>
                  <b-col cols="1"></b-col>
                  <b-col cols="2">
                    <label class="mr-2">Ngày hết hạn</label>
                  </b-col>
                  <b-col cols="3">
                    <my-date-picker v-model="ngayhethan_selected"></my-date-picker>
                  </b-col>
                </b-row> -->
                <b-row class="mb-4">
                  <b-col cols>
                    <b>
                      Shooting date
                      <!-- Ngày quay -->
                    </b>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      From
                      <!-- Từ ngày -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <my-date-picker v-model="ngaybatdau_selected" :disabled="true"></my-date-picker>
                  </b-col>
                  <b-col cols="1">
                    <button class="btn btn-secondary" @click.prevent="openDateModal"><i class="fas fa-calendar"></i></button>
                  </b-col>
                  <b-col cols="2">
                    <label class="mr-2">
                      To
                      <!-- Đến ngày -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <my-date-picker v-model="ngayketthuc_selected" :disabled="true"></my-date-picker>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Total days:
                      <!-- Số ngày tổng cộng: -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                     <b-form-input class="mr-2" v-model="total_date" style="width: 15%;" disabled></b-form-input>
                  </b-col>
                </b-row>
                <br/><br/>
                <b-row class="mb-4">
                  <b-col cols>
                    <b>
                      Customer information
                      <!-- Thông tin khách hàng -->
                    </b>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Customer
                      <!-- Khách hàng -->
                    </label>
                    <code>*</code>
                  </b-col>
                  <b-col cols="3">
                    <multiselect
                      v-model="khachhang_selected"
                      :placeholder="khachhang_selected == null ? '' : khachhang_selected.tenkhachhang"
                      track-by="id"
                      label="ten"
                      selectedLabel="Đang chọn"
                      select-label="Enter để chọn"
                      deselectLabel="Enter để xóa"
                      :searchable="true"
                      :loading="isLoading"
                      :options="customers"
                      @search-change="findCustomer"
                      @select="unlockNguoiPhuTrach"
                      @remove="lockNguoiPhuTrach"
                      required
                    ></multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Phone
                      <!-- ĐT -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input v-model="item.dienthoai" readonly></b-form-input>
                  </b-col>
                  <b-col cols="1"></b-col>
                  <b-col cols="2">
                    <label class="mr-2">Email</label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input v-model="item.email" readonly></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Tax code
                      <!-- MST -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input v-model="item.masothue" readonly></b-form-input>
                  </b-col>
                  <b-col cols="1"></b-col>
                  <b-col cols="2">
                    <label class="mr-2">
                      Bank account
                      <!-- Tài khoản NH -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input v-model="item.taikhoannganhang" readonly></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Address
                      <!-- Địa chỉ -->
                    </label>
                  </b-col>
                  <b-col cols="9">
                    <b-form-input v-model="item.diachi" readonly></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Key contact
                      <!-- Người phụ trách -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <multiselect
                      v-model="nguoiphutrach_selected"
                      placeholder
                      track-by="id"
                      label="ten"
                      selectedLabel="Đang chọn"
                      select-label="Enter để chọn"
                      deselectLabel="Enter để xóa"
                      :searchable="true"
                      :loading="isLoading"
                      :options="contacts"
                      @select="(info) => {this.contact_infos.push(info);}"
                      @remove="() => {this.contact_infos = [];}"
                      :disabled="!nguoiphutrach_enabled"
                    ></multiselect>
                  </b-col>
                </b-row>
                <b-table
                  v-if="contact_infos.length > 0"
                  bordered
                  head-variant="dark"
                  hover
                  small
                  responsive
                  :fields="lienheFields"
                  :items="contact_infos"
                  table-variant="light"
                >
                  <template v-slot:cell(ngaysinh)="data">
                    {{data.item.ngaysinh | moment('DD/MM/YYYY')}}
                  </template>
                </b-table>
              </form>
            </b-tab>
            <b-tab title="Attachment File">
              <contract-attach v-if="tabIndex == 1" :item="item"/>
            </b-tab>
            <b-tab title="Payment">
              <form @submit.prevent="submitItem" autocomplete="off">
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Estimated product delivery date
                      <!-- Ngày bàn giao sản phẩm dự kiến -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                      <my-date-picker v-model="ngaybangiao_selected"></my-date-picker>
                  </b-col>
                  <b-col cols="2">
                    <label class="mr-2">
                      Actual product delivery date
                      <!-- Ngày bàn giao sản phẩm thực tế -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <my-date-picker v-model="ngaybangiaothucte_selected"></my-date-picker>
                  </b-col>
                  <b-col>
                    <button class="btn btn-info" type="submit">
                      <i class="fas fa-save"></i>
                      Save
                      <!-- Lưu -->
                  </button>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Estimated acceptance date
                      <!-- Ngày nghiệm thu dự kiến -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                      <my-date-picker v-model="ngayxacnhannghiemthu_selected"></my-date-picker>
                  </b-col>
                  <b-col cols="2">
                    <label class="mr-2">
                      Actual acceptance date
                      <!-- Ngày nghiệm thu thực tế -->
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <my-date-picker v-model="ngaynghiemthu_selected"></my-date-picker>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="2">
                    <label class="mr-2">
                      Acceptance value
                      <!-- Giá trị nghiệm thu -->
                    </label>
                  </b-col>
                  <b-col cols="2">
                      <my-currency-input v-model="item.giatriduocnghiemthu"/>
                  </b-col>
                  <b-col cols="1">
                    <label class="mr-2">
                      Paid
                      <!-- Đã thanh toán -->
                    </label>
                  </b-col>
                  <b-col cols="2">
                    <b-form-input :value="item.dathu | numeral('0,0')" readonly></b-form-input>
                  </b-col>
                  <b-col cols="1">
                    <label class="mr-2">
                      Remaining amount
                      <!-- Còn phải thanh toán -->
                    </label>
                  </b-col>
                  <b-col cols="2">
                    <b-form-input :value="still_left | numeral('0,0')" readonly></b-form-input>
                  </b-col>
                </b-row>
              </form>

              <!-- PAYMENT -->
              <button class="btn btn-info mb-3" @click.prevent="openPaymentModal">
                 <i class="fas fa-plus"></i>
                 Add payment
                 <!-- Thêm đợt thanh toán -->
              </button>
              <b-table
                bordered
                head-variant="dark"
                hover
                responsive
                striped
                small
                sticky-header="450px"
                table-variant="light"
                :fields="payFields"
                :items="payItems"
              >
                <template v-slot:cell(ngaynhan)="data">
                  <span> {{ data.item.ngaynhan | moment('DD/MM/YYYY')}} </span>
                </template>
                <template v-slot:cell(ngaynhandukien)="data">
                  <span> {{ data.item.ngaynhandukien | moment('DD/MM/YYYY')}} </span>
                </template>
                <!-- <template v-slot:cell(tylephantram)="data">{{data.item.tylephantram == null ? '' : data.item.tylephantram + "%"}}</template> -->
                <template v-slot:cell(tylephantram)="data">{{data.item.tylephantram == null ? '' : data.item.tylephantram}}</template>
                <template v-slot:cell(sotien)="data">{{data.item.sotien | numeral('0,0')}}</template>
                <template v-slot:cell(action)="data">
                  <b-link class="text-primary mr-2" href="#" @click="openEditPaymentModal(data)">
                    <i class="fas fa-pencil-alt"></i>
                  </b-link>
                  <b-link class="text-danger" href="#" @click="deletePayment(data)">
                    <i class="fas fa-trash"></i>
                  </b-link>
                </template>
              </b-table>
              <br>
              <!-- END OF PAYMENT -->

              <!-- EXTRA -->
              <!-- <button class="btn btn-warning mb-3" @click.prevent="openExtraModal">
                  <i class="fas fa-plus"></i> Thêm chi phí phát sinh
              </button>
              <b-form-input :value="extra_total | numeral('0,0')" disabled></b-form-input> -->

              <b-row>
                  <!-- <button class="btn btn-warning mb-3" @click.prevent="openExtraModal" style="width: 100%"> -->
                <b-col cols="2">
                  <button class="btn btn-warning mb-3" @click.prevent="openExtraModal">
                    <i class="fas fa-plus"></i>
                    Add costs incurred
                    <!-- Thêm chi phí phát sinh -->
                  </button>
                </b-col>
                <b-col cols="2">
                  <b-form-input :value="extra_total | numeral('0,0')" disabled></b-form-input>
                </b-col>
              </b-row>
              <b-table
                bordered
                head-variant="dark"
                hover
                responsive
                striped
                small
                sticky-header="450px"
                table-variant="light"
                :fields="extraFields"
                :items="extraItems"
              >
                <template v-slot:cell(ngayphatsinh)="data">
                  <span> {{ data.item.ngayphatsinh | moment('DD/MM/YYYY')}} </span>
                </template>
                <template v-slot:cell(sotien)="data">{{data.item.sotien | numeral('0,0')}}</template>
                <template v-slot:cell(action)="data">
                  <b-link class="text-danger mr-2" href="#" @click="deleteExtra(data)">
                    <i class="fas fa-trash"></i>
                  </b-link>
                </template>
              </b-table>
              <!-- END OF EXTRA -->

            </b-tab>
            <b-tab title="Note">
              <b-form-row class="mb-2">
                <b-col cols="11">
                  <b-form-textarea v-model="item.hopdong_note" rows="10"></b-form-textarea>
                </b-col>
                <b-col>
                    <button class="btn btn-info" @click.prevent="submitItem">
                      <i class="fas fa-save"></i>
                      Save
                      <!-- Lưu -->
                  </button>
                </b-col>
              </b-form-row>
              <!-- <b-form-row>

                <b-col cols="12">
                  <button class="btn btn-primary" style="display: block;width: 100%;" @click.prevent="submitItem">Lưu</button>
                </b-col>
              </b-form-row> -->
            </b-tab>
            <!-- <b-tab title="Chi phí" v-if="profit_and_loss" >
              <container>
                <b-row class="mb-4">
                  <b-col cols="3">
                    <label class="mr-2">Chi phí</label>
                    <form @submit.prevent="calculateProfit" class="form-inline mb-4">
                      <div class="form-group mr-3">
                        <my-currency-input v-model="item.chiphi"/>
                      </div>
                      <button class="btn btn-info" type="submit">
                          <i class="fas fa-plus"></i> Tính chi phí
                      </button>
                    </form>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col cols="3">
                    <label class="mr-2">Doanh thu</label>
                    <b-form-input :value="item.giatriduocnghiemthu | numeral('0,0')" readonly></b-form-input>
                  </b-col>
                  <b-col cols="3">
                    <label class="mr-2">Lợi nhuận </label>
                    <b-form-input :value="profit | numeral('0,0')" readonly></b-form-input>
                  </b-col>
                  <b-col cols="3">
                    <label class="mr-2">Return on sales</label>
                    <b-form-input v-model="profit_percentage" readonly></b-form-input>
                  </b-col>
                </b-row>
              </container>
            </b-tab> -->
          </b-tabs>
        </b-card>
      </div>
    </div>

    <!-- PAYMENT MODAL -->
    <b-modal
      v-model="payModalShow"
      header-bg-variant="info"
      header-text-variant="light"
      size="xl"
      @hidden="closePaymentModal"
      hide-footer
    >
      <template v-slot:modal-title>
        <div>
          Add payment
          <!-- Thêm đợt thanh toán -->
        </div>
      </template>
      <b-container>
        <form @submit.prevent="storePayment" autocomplete="off">
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Payment Name
                <!-- Tên đợt thanh toán -->
              </label>
              <code>*</code>
            </b-col>
            <b-col cols="9">
              <b-form-select
                v-model="paymentItem.ten"
                :options="optionsTen"
                value-field="value"
                text-field="text"
                required
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Invoice No.
                <!-- Số hóa đơn -->
              </label>
            </b-col>
            <b-col cols="9">
              <b-form-input v-model="paymentItem.sohoadon"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Payment amount
                <!-- Số tiền thanh toán -->
              </label>
              <code>*</code>
            </b-col>
            <b-col cols="3">
              <my-currency-input v-model="paymentItem.sotien" required/>
            </b-col>
            <b-col cols="2">
              <label class="mr-2">
                Percentage
                <!-- Tỷ lệ -->
              </label>
            </b-col>
            <b-col cols="2">
              <b-form-input v-model="paymentItem.tylephantram" readonly></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Estimated date
                <!-- Ngày dự kiến -->
              </label>
              <code>*</code>
            </b-col>
            <b-col cols="3">
              <my-date-picker v-model="Ngaynhandukien_selected" :required="true"></my-date-picker>
            </b-col>
            <b-col cols="2">
              <label class="mr-2">
                Payment date
                <!-- Ngày thanh toán -->
              </label>
            </b-col>
            <b-col cols="3">
              <my-date-picker v-model="Ngaynhan_selected"></my-date-picker>
            </b-col>
          </b-row>
          <div class="form-inline">
          <div style="flex-grow: 1"></div>
          <b-button class="mr-3" type="submit" variant="info">
            <i class="fas fa-save mr-2"></i>
            Save
            <!-- Lưu -->
          </b-button>
          <b-button variant="secondary" @click="closePaymentModal">
            <i class="fas fa-times mr-2"></i>
            Close
            <!-- Đóng -->
          </b-button>
        </div>
        </form>
        </b-container>
    </b-modal>
    <!-- END OF PAYMENT MODAL -->

    <!-- EDIT PAYMENT MODAL -->
    <b-modal
      v-model="editPaymentModalShow"
      header-bg-variant="info"
      header-text-variant="light"
      @hidden="closeEditPaymentModal"
      size="xs"
      hide-footer
    >
      <template v-slot:modal-title>
        <div>Cập nhật ngày thanh toán thực tế</div>
      </template>
      <b-row class="mb-2">
        <b-col cols="4">
          <label class="mr-2">Số hóa đơn</label>
        </b-col>
        <b-col cols="8">
          <b-form-input v-model="so_hoa_don"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label class="mr-2">Ngày thanh toán</label>
        </b-col>
        <b-col cols="5">
          <my-date-picker v-model="edit_date"></my-date-picker>
        </b-col>
        <b-col cols="3">
          <b-button class="mr-3" @click.prevent="storeEditDate" variant="info">
            <i class="fas fa-save mr-2"></i>
            Save
            <!-- Lưu -->
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <!-- END OF EDIT PAYMENT MODAL -->

    <!-- EXTRA MODAL -->
    <b-modal
      v-model="extraModalShow"
      header-bg-variant="info"
      header-text-variant="light"
      @hidden="closeExtraModal"
      size="xl"
      hide-footer
    >
      <template v-slot:modal-title>
        <div>
          Add costs incurred
          <!-- Thêm chi phí phát sinh -->
        </div>
      </template>
      <b-container>
        <form @submit.prevent="storeExtra" autocomplete="off">
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Name
                <!-- Tên chi phí -->
              </label>
              <code>*</code>
            </b-col>
            <b-col cols="3">
              <b-form-input v-model="extraItem.ten" required></b-form-input>
            </b-col>
            <b-col cols="2">
              <label class="mr-2">
                Amount
                <!-- Số tiền thanh toán -->
              </label>
              <code>*</code>
            </b-col>
            <b-col cols="3">
              <my-currency-input v-model="extraItem.sotien" required/>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Incurred date
                <!-- Ngày phát sinh -->
              </label>
              <code>*</code>
            </b-col>
            <b-col cols="3">
              <my-date-picker v-model="ngayphatsinh_selected" :required="true"></my-date-picker>
            </b-col>
            <b-col cols="2">
              <label class="mr-2">
                Appendix No.
                <!-- Số phụ lục -->
              </label>
            </b-col>
            <b-col cols="3">
              <b-form-input v-model="extraItem.sophuluc"></b-form-input>
            </b-col>
          </b-row>
          <div class="form-inline">
          <div style="flex-grow: 1"></div>
          <b-button class="mr-3" type="submit" variant="info">
            <i class="fas fa-save mr-2"></i>
            Save
            <!-- Lưu -->
          </b-button>
          <b-button variant="secondary" @click="closeExtraModal">
            <i class="fas fa-times mr-2"></i>Close
            <!-- Đóng -->
          </b-button>
        </div>
        </form>
        </b-container>
    </b-modal>
    <!-- END OF EXTRA MODAL -->

    <!-- DATE MODAL -->
    <b-modal
      v-model="dateModalShow"
      header-bg-variant="info"
      header-text-variant="light"
      @hidden="closeDateModal"
      size="lg"
      hide-footer
    >
      <template v-slot:modal-title>
        <div>
          Add shooting dates
          <!-- Thêm các đợt quay -->
        </div>
      </template>
      <b-container>
        <form @submit.prevent="storeDate" autocomplete="off">
          <!-- <b-row class="mb-4"> -->
            <!-- No need content -->
            <!-- <b-col cols="2">
              <label class="mr-2">Nội dung</label>
            </b-col>
            <b-col cols="9">
              <b-form-input v-model="dateItem.ten" required></b-form-input>
            </b-col> -->

          <!-- </b-row> -->
          <b-row class="mb-4">
            <b-col cols="2">
              <!-- <label class="mr-2">Ngày bắt đầu</label> -->
              <label>
                Start date
                <!-- Ngày bắt đầu -->
              </label>
            </b-col>
            <b-col cols="4">
              <my-date-picker v-model="ngaybatdau_selected" :required="true"></my-date-picker>
            </b-col>
            <b-col cols="2">
              <label style="width: 110%;">
                End date
                <!-- Ngày kết thúc -->
              </label>
            </b-col>
            <b-col cols="4">
              <my-date-picker v-model="ngayketthuc_selected" :required="true"></my-date-picker>
            </b-col>
          </b-row>
          <b-table
            bordered
            head-variant="dark"
            hover
            small
            responsive
            striped
            :fields="dateFields"
            :items="dateItems"
            table-variant="light"
          >
            <template v-slot:cell(ngaybatdau)="data">
              {{data.item.ngaybatdau | moment('DD/MM/YYYY')}}
            </template>
            <template v-slot:cell(ngayketthuc)="data">
              {{data.item.ngayketthuc | moment('DD/MM/YYYY')}}
            </template>
            <template v-slot:cell(action)="data">
              <!-- <b-link class="text-primary mr-2" href="#" @click="openEditDateModal(data)">
                <i class="fas fa-pencil-alt"></i>
              </b-link> -->
              <b-link class="text-danger" href="#" @click="deleteDate(data)">
                <i class="fas fa-trash"></i>
              </b-link>
            </template>
          </b-table>
          <b-row class="mb-4">
            <b-col>
              <div class="form-inline">
                <div style="flex-grow: 1"></div>
                <label class="mr-2">
                  Total days:
                  <!-- Số ngày tổng cộng: -->
                </label>
                <b-form-input class="mr-2" v-model="total_date" style="width: 8%;" disabled></b-form-input>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="form-inline">
                <div style="flex-grow: 1"></div>
                <b-button class="mr-3" type="submit" variant="info">
                  <i class="fas fa-save mr-2"></i>
                  Save
                  <!-- Lưu -->
                </b-button>
                <b-button variant="secondary" @click="closeDateModal">
                  <i class="fas fa-times mr-2"></i>
                  Close
                  <!-- Đóng -->
                </b-button>
              </div>
            </b-col>
          </b-row>
        </form>
      </b-container>
    </b-modal>
    <!-- END OF DATE MODAL -->
  </div>
</template>

<script>
import axios from "axios";
//import ContractSideBar from "../components/Contract/ContractSideBar";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import MyCurrencyInput from "../components/App/MyCurrencyInput";
import ContractAttach from "../components/Contract/ContractAttach";
import MyDatePicker from  "../components/App/MyDatePicker";

export default {
  name: "ContractUpdate",
  components: {
    //ContractSideBar,
    Multiselect,
    VueDatepickerLocal,
    MyCurrencyInput,
    ContractAttach,
    MyDatePicker,
  },
  data() {
    return {
      tabIndex: 0,
      item: {
        id: 0,
        tieude: null,
        sohopdong: null,
        loaihinhhopdong: 0,
        giatrihopdong: 0,
        giatriduocnghiemthu: 0,
        phamvicongviec: '',
        thoigiansudung: null,
        ngayky: "",
        ngaybatdau: "",
        ngayketthuc: "",
        ngaybangiao: "",
        ngaybangiaothucte: "",
        ngayphatsong: "",
        ngayxacnhannghiemthu: "",
        ngaynghiemthu: "",
        dacdiem: 0,
        kenhduocsudung: '',
        departmentid: null,
        chiphi: 0,
        dathu: 0,

        ngayhieuluc: "",
        ngayhethan: "",
        tinhtrang: null,

        customer: null,
        customerId: null,
        diachi: null,
        dienthoai: null,
        email: null,
        masothue: null,
        taikhoannganhang: null,
        customercontactid: null,

        duan_tylethuong: null,
        hopdong_note: null,
        duan_lock: false,
      },

      payFields: [
        {
          key: "ten",
          label: "Name",
          // label: "Đợt thanh toán",1
        },
        {
          key: "sohoadon",
          label: "Invoice No.",
          // label: "Số hóa đơn",
        },
        {
          key: "sotien",
          label: "Số tiền thanh toán",
          // label: "Số tiền thanh toán",
        },
        {
          key: "tylephantram",
          label: "Percentage",
          // label: "Phần trăm thanh toán",
        },
        {
          key: "ngaynhandukien",
          label: "Estimated date",
          // label: "Ngày thanh toán dự kiến",
        },
        {
          key: "ngaynhan",
          label: "Payment date",
          // label: "Ngày thanh toán",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "50px !important" },
        },
      ],

      extraFields: [
        {
          key: "ten",
          label: "Name",
          // label: "Chi phí",
        },
        {
          key: "sotien",
          label: "Amount",
          // label: "Số tiền",
        },
        // {
        //   key: "sotien",
        //   label: "Số tiền",
        // },
        {
          key: "ngayphatsinh",
          label: "Incurred date",
          // label: "Ngày phát sinh",
        },
        {
          key: "sophuluc",
          label: "Appendix No.",
          // label: "Số phụ lục",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "30px !important" },
        },
      ],

      lienheFields: [
        {
          key: "ten",
          label: "Tên",
        },
        {
          key: "chucdanh",
          label: "Chức danh",
        },
        {
          key: "dienthoai",
          label: "Điện thoại",
        },
        {
          key: "email",
          label: "Email",
        },
        {
          key: "ngaysinh",
          label: "Ngày sinh",
        },
        {
          key: "diachi",
          label: "Địa chỉ nhà",
        },
      ],

      paymentItem: {
        id: 0,
        CustomerContractId: 0,
        ten: null,
        sohoadon: null,
        sotien: 0,
        tylephantram: 0,
        Ngaynhandukien: "",
        Ngaynhan: "",
      },

      extraItem: {
        id: 0,
        CustomerContractId: 0,
        ten: null,
        sotien: 0,
        ngayphatsinh: "",
        sophuluc: null,
      },

      ngayphatsinh_selected: "",
      Ngaynhandukien_selected: "",
      Ngaynhan_selected: "",
      ngayhieuluc_selected: "",
      ngayhethan_selected: "",
      ngaybatdau_selected: "",
      ngayketthuc_selected: "",
      ngaybangiao_selected: "",
      ngaybangiaothucte_selected: "",
      ngayxacnhannghiemthu_selected: "",
      ngaynghiemthu_selected: "",

      optionsTen_tempalte:  [{value: "Đợt 1", text: "Đợt 1"}, {value: "Đợt 2", text: "Đợt 2"}, {value: "Đợt 3", text: "Đợt 3"}, {value: "Đợt 4", text: "Đợt 4"}, {value: "Đợt 5", text: "Đợt 5"},],
      optionsTen: [],

      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },

      tepdinhkemfile: null,
      khachhang_selected: null,
      isLoading: false,
      customers: [],

      payItems: [],
      extraItems: [],
      extraModalShow: false,

      payModalShow: false,
      nguoiphutrach_enabled: false,
      nguoiphutrach_selected: null,

      editPaymentModalShow: false,

      optionsTinhTrang: [],
      optionsLoaihinhhopdong: [],
      optionsDacdiem: [],
      contacts: [],
      contact_infos: [],

      profit: 0,
      profit_percentage: "",

      extra_total: 0,

      fields: [
        {
          key: "name",
          label: "File",
          // label: "Tệp đính kèm",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "150px !important" },
        },
      ],

      edit_id: 0,
      edit_date: "",
      old_edit_date: "",
      so_hoa_don: "",
      changed: false,

      departments: [],

      dateModalShow: false,
      dateItems: [],
      dateFields: [
        // {
        //   key: "ten",
        //   label: "Nội dung"
        // },
        {
          key: "ngaybatdau",
          label: "Start date",
          // label: "Ngày bắt đầu quay",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "ngayketthuc",
          label: "End date",
          // label: "Ngày kết thúc",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thStyle: { width: "80px !important" },
        },
      ],

      dateItem: {
        id: 0,
        customercontactid: 0,
        ngaybatdau: "",
        ngayketthuc: "",
        songay: 0,
      },

      // ngaybatdau_selected: "",
      // ngayketthuc_selected: "",

    };
  },

  computed: {
    profit_and_loss() {
      return this.$store.getters.hasPermission("profit_and_loss");
    },

    still_left() {
      if (this.item.giatriduocnghiemthu != 0) return this.item.giatriduocnghiemthu - this.item.dathu;
      return 0;
    },

    total_date() {
      var total = 0;
      for (var date of this.dateItems) {
        total += date.songay;
      }

      return total;
    }
  },

  beforeRouteEnter(to, from, next) {
    if (!(to.params.id && to.params.id.length)) {
      next();
    } else {
      axios.all([
        axios.get(`/api/customercontract/${to.params.id}`),
        axios.get("/api/picklist/loaihinhhopdong"),
        axios.get("/api/picklist/dacdiem"),
        axios.get("/api/picklist/tinhtranghopdong"),
        axios.get(`/api/customercontractpay/${to.params.id}`),
        axios.get("/api/customer"),
        axios.get(`/api/customercontractpay/extra/${to.params.id}`),
        axios.get("/api/department"),
        axios.get(`/api/customercontract/date/${to.params.id}`)
      ])
      .then(
        axios.spread((customercontract, loaihinhhopdong, dacdiem, tinhtranghopdong, customercontractpay, customer, extra, department, customercontractdate) => {
          next((vm) => {
            vm.initData(customercontract.data, loaihinhhopdong.data, dacdiem.data, tinhtranghopdong.data, customercontractpay.data, customer.data, extra.data, department.data, customercontractdate.data);
          });
        })
      );
    }
  },

  watch: {
    khachhang_selected: function (newValue, oldValue) {
      if (newValue != null) {
        this.item.customerId = newValue.id;
        this.item.dienthoai = newValue.dienthoai;
        this.item.diachi = newValue.diachi;
        this.item.masothue = newValue.masothue;
        this.item.email = newValue.email;
        this.item.taikhoannganhang = newValue.taikhoannganhang;
      }
    },
    'paymentItem.sotien': function (newValue, oldValue) {
      if (this.item.giatriduocnghiemthu == 0) return;

      //this.paymentItem.tylephantram = ((newValue * 100)/ this.item.giatriduocnghiemthu).toFixed(2);
      this.paymentItem.tylephantram = ((newValue * 100)/ this.item.giatriduocnghiemthu).toFixed(0) +"%";
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    initData(customercontracts, loaihinhhopdongs, dacdiems, tinhtranghopdongs, customercontractpays, customers, extras, departments, customercontractdates) {
      if (customercontracts) {
        this.item = customercontracts;
        this.payItems = customercontractpays;
        this.extraItems = extras;
        this.khachhang_selected = customercontracts.customer;
        this.customers = customers;
        this.dateItems = customercontractdates;

        this.ngaybangiao_selected =  this.$convert_date_string(this.item.ngaybangiao);
        this.ngaybangiaothucte_selected = this.$convert_date_string(this.item.ngaybangiaothucte);
        this.ngayxacnhannghiemthu_selected =  this.$convert_date_string(this.item.ngayxacnhannghiemthu);
        this.ngaynghiemthu_selected = this.$convert_date_string(this.item.ngaynghiemthu);
        this.ngayhieuluc_selected = this.$convert_date_string(this.item.ngayhieuluc);
        this.ngayhethan_selected = this.$convert_date_string(this.item.ngayhethan);
        this.ngaybatdau_selected = this.$convert_date_string(this.item.ngaybatdau);
        this.ngayketthuc_selected = this.$convert_date_string(this.item.ngayketthuc);

        this.optionsLoaihinhhopdong = loaihinhhopdongs;
        this.optionsDacdiem = dacdiems;
        this.optionsTinhTrang = tinhtranghopdongs;
        this.departments = departments;

        this.optionsLoaihinhhopdong.unshift({ id: null, pickListValue: ""});

        if (this.item.sohopdong == "null") this.item.sohopdong = "";
        if (this.item.thoigiansudung == "null") this.item.thoigiansudung = "";

        this.profit = this.item.giatriduocnghiemthu - this.item.chiphi;
        this.profit_percentage =  (((this.item.giatriduocnghiemthu - this.item.chiphi) / this.item.giatriduocnghiemthu) * 100) + "%";


        axios
          .get(`/api/customercontact/${customercontracts.customer.id}`)
          .then((res) => {
            this.contacts = res.data;
            if (customercontracts.customercontactid != null) this.nguoiphutrach_selected = this.contacts.find(x => x.id == customercontracts.customercontactid);
            this.contact_infos.push(this.nguoiphutrach_selected);
            this.nguoiphutrach_enabled = true;
          })
          .catch((err) => {
              this.$toast.error(err.response.data + "", "Lỗi", { timeout: 3000 });
          });

        for (var ex of this.extraItems) {this.extra_total += ex.sotien;}
      }
    },

    findCustomer(query) {
      if (query && query.length) {
        this.isLoading = true;
        axios.get(`/api/customer?q=${query}`).then((response) => {
          this.isLoading = false;
          this.customers = response.data;
        });
      }
    },

    submitItem() {
      if (
        !(this.item.tieude && this.item.tieude.length) ||
        !(this.item.customerId && this.item.customerId > 0)
      ) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
      } else {
        this.item.ngaybangiao = this.$convert_string_date(this.ngaybangiao_selected);
        this.item.ngaybangiaothucte = this.$convert_string_date(this.ngaybangiaothucte_selected);
        this.item.ngayxacnhannghiemthu = this.$convert_string_date(this.ngayxacnhannghiemthu_selected);
        this.item.ngaynghiemthu = this.$convert_string_date(this.ngaynghiemthu_selected);

        this.item.ngayhieuluc = this.$convert_string_date(this.ngayhieuluc_selected);
        this.item.ngayhethan = this.$convert_string_date(this.ngayhethan_selected);
        this.item.ngaybatdau = this.$convert_string_date(this.ngaybatdau_selected);
        this.item.ngayketthuc = this.$convert_string_date(this.ngayketthuc_selected);

        if (this.nguoiphutrach_selected != null) this.item.customercontactid = this.nguoiphutrach_selected.id;
        else this.item.customercontactid = null;

        axios
          .put("/api/customercontract", this.item)
          .then((res) => {
            this.item.tinhtrang = res.data;
            this.$toast.success("Cập nhật thông tin thành công !", "Thành công", {timeout: 2000});
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
          });
      }
    },

    storePayment() {
      this.paymentItem.CustomerContractId = this.item.id;
      this.paymentItem.Ngaynhandukien = this.$convert_string_date(this.Ngaynhandukien_selected);
      this.paymentItem.Ngaynhan = this.$convert_string_date(this.Ngaynhan_selected);

      axios
        .post("/api/customercontractpay", this.paymentItem)
        .then((res) => {
            this.item.dathu = res.data.dathu;
            this.payItems.push(res.data);
            this.$toast.success("Thêm đợt thanh toán thành công !", "Thành công", {timeout: 2000});
            this.closePaymentModal();

        })
        .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },

    deletePayment(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
                timeout: 20000,
                close: false,
                overlay: true,
                displayMode: "once",
                position: "center",
                buttons: [
                    [
                        "<button><b>Có</b></button>",
                        (instance, toast) => {
                            axios
                            .delete(`/api/customercontractpay/${data.item.id}`)
                            .then((res) => {
                                this.payItems.splice(data.index, 1);
                                this.item.dathu = res.data.dathu;
                                this.$toast.success("Xóa đợt thanh toán thành công !", "Thành công", {timeout: 2000});
                                this.closePaymentModal();
                            })
                            .catch((err) => {
                              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
                            });
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                        true,
                    ],
                    [
                        "<button>Không</button>",
                        function (instance, toast) {
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                    ],
                ],
            });
    },

    storeExtra() {
      this.extraItem.CustomerContractId = this.item.id;
      this.extraItem.ngayphatsinh = this.$convert_string_date(this.ngayphatsinh_selected);

      axios
        .post("/api/customercontractpay/extra", this.extraItem)
        .then((res) => {
            this.item.giatriduocnghiemthu = res.data.giatriduocnghiemthu;
            this.extraItems.push(res.data);
            this.extra_total += res.data.sotien;
            this.$toast.success("Thêm đợt chi phí phát sinh thành công !", "Thành công", {timeout: 2000});
            this.closeExtraModal();

        })
        .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },

    deleteExtra(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
          timeout: 20000,
          close: false,
          overlay: true,
          displayMode: "once",
          position: "center",
          buttons: [
              [
                  "<button><b>Có</b></button>",
                  (instance, toast) => {
                      axios
                      .delete(`/api/customercontractpay/extra/${data.item.id}`)
                      .then((res) => {
                          this.extraItems.splice(data.index, 1);
                          this.item.giatriduocnghiemthu = res.data.giatriduocnghiemthu;
                          this.extra_total -= res.data.sotien;
                          this.$toast.success("Xóa đợt thanh toán thành công !", "Thành công", {timeout: 2000});
                          this.closeExtraModal();
                      })
                      .catch((err) => {
                        this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
                      });
                      instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                  },
                  true,
              ],
              [
                  "<button>Không</button>",
                  function (instance, toast) {
                      instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                  },
              ],
          ],
      });
    },

    openExtraModal() {
      this.extraModalShow = true;
    },

    closeExtraModal() {
      this.extraItem.ten = null;
      this.extraItem.sotien = 0;
      this.extraItem.ngayphatsinh =  "";
      this.extraItem.sophuluc =  null;
      this.extraModalShow = false;
    },

    openPaymentModal() {
      this.optionsTen = this.optionsTen_tempalte.slice();

      for (var item of this.payItems) {
        const found = this.optionsTen.find(x => {if (x.value == item.ten) return x;});
        if (found != null) this.optionsTen.splice(this.optionsTen.indexOf(found), 1);
      }

      if (this.optionsTen.length < 1) this.$toast.error("Đã thanh toán đủ 5 đợt!", "Lỗi", { timeout: 3000 });
      else this.payModalShow = true;
    },

    openEditPaymentModal(data) {
      this.editPaymentModalShow = true;
      this.edit_id = data.item.id;
      this.edit_date = this.$convert_date_string(data.item.ngaynhan);
      this.old_edit_date = this.$convert_date_string(data.item.ngaynhan);
    },

    closeEditPaymentModal() {
      this.editPaymentModalShow = false;
      this.change = false;
    },

    storeEditDate() {
      if (this.edit_date != "") this.edit_date = this.$convert_string_date(this.edit_date);
      this.old_edit_date = this.$convert_string_date(this.old_edit_date);

      if (this.edit_date != this.old_edit_date) this.changed = true;

      var formData = new FormData();
      formData.append("id", this.edit_id);
      formData.append("date", this.edit_date == "" ? "" : this.edit_date.toUTCString());
      formData.append("sohoadon", this.so_hoa_don);
      formData.append("changed", this.changed);

      axios
        .put("/api/customercontractpay", formData)
        .then((res) => {
          const itemIndex = this.payItems.findIndex((x) => x.id === res.data.id);
          this.payItems[itemIndex] = JSON.parse(JSON.stringify(res.data));
          const temp = JSON.parse(JSON.stringify(this.payItems));
          this.payItems = JSON.parse(JSON.stringify(temp));

          this.item.dathu = res.data.dathu;
          this.$toast.success("Thêm đợt thanh toán thành công !", "Thành công", {timeout: 2000});
          this.closeEditPaymentModal();

        })
        .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },

    closePaymentModal() {
      this.paymentItem.ten = null;
      this.paymentItem.sotien = 0;
      this.paymentItem.sohoadon = null;
      this.paymentItem.tylephantram = 0;
      this.Ngaynhandukien_selected = "";
      this.Ngaynhan_selected = "";
      this.payModalShow = false
    },

    openDateModal() {
      this.dateModalShow = true;
    },

    closeDateModal() {
      this.dateModalShow = false;
    },

    storeDate() {
      let ngaybd = this.$convert_string_date(this.ngaybatdau_selected);
      let ngaykt = this.$convert_string_date(this.ngayketthuc_selected);

      if (ngaybd > ngaykt) {
        this.$toast.error("Ngày bắt đầu phải nhỏ hơn hoặc bằng ngày kết thúc", "Lỗi", { timeout: 3000 });
        return;
      }
      this.dateItem.customercontractid = this.item.id;
      this.dateItem.songay = this.date_different(this.ngaybatdau_selected, this.ngayketthuc_selected);

      this.dateItem.ngaybatdau  = this.$convert_string_date(this.ngaybatdau_selected);
      this.dateItem.ngayketthuc = this.$convert_string_date(this.ngayketthuc_selected);

      // if (this.dateItem.ngaybatdau > this.dateItem.ngayketthuc) {
      //   this.$toast.error("Ngày bắt đầu phải nhỏ hơn hoặc bằng ngày kết thúc", "Lỗi", { timeout: 3000 });
      //   return;
      // }
      axios
        .post("/api/customercontract/date", this.dateItem)
        .then((res) => {
            this.dateItems.push(res.data);
            axios.put(`/api/customercontract/firstandlast/${this.item.id}`).then((rec) => {this.ngaybatdau_selected = this.$convert_date_string(rec.data.ngaybatdau); this.ngayketthuc_selected = this.$convert_date_string(rec.data.ngayketthuc)});
            this.$toast.success("Thêm đợt quay thành công !", "Thành công", {timeout: 2000});
            this.clearDateModal();
        })
        .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },

    deleteDate(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
          timeout: 20000,
          close: false,
          overlay: true,
          displayMode: "once",
          position: "center",
          buttons: [
              [
                  "<button><b>Có</b></button>",
                  (instance, toast) => {
                      axios
                      .delete(`/api/customercontract/date/${data.item.id}`)
                      .then((res) => {
                          this.dateItems.splice(data.index, 1);
                          axios.put(`/api/customercontract/firstandlast/${this.item.id}`).then((rec) => {this.ngaybatdau_selected = this.$convert_date_string(rec.data.ngaybatdau); this.ngayketthuc_selected = this.$convert_date_string(rec.data.ngayketthuc)});
                          this.$toast.success("Xóa đợt đợt quay công !", "Thành công", {timeout: 2000});
                      })
                      .catch((err) => {
                        this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
                      });
                      instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                  },
                  true,
              ],
              [
                  "<button>Không</button>",
                  function (instance, toast) {
                      instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                  },
              ],
          ],
      });

    },

    clearDateModal() {
      this.dateItem.ten = "";
      this.ngaybatdau_selected = "";
      this.ngayketthuc_selected = "";
    },

    calculateProfit() {
      this.profit = this.item.giatriduocnghiemthu - this.item.chiphi;
      this.profit_percentage =  (((this.item.giatriduocnghiemthu - this.item.chiphi) / this.item.giatriduocnghiemthu) * 100) + "%";

      this.item.duan_tylethuong = parseFloat(this.profit_percentage);

      axios
        .put("/api/customercontract", this.item)
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },

    unlockNguoiPhuTrach(contact) {
      this.lockNguoiPhuTrach();

      axios
        .get(`/api/customercontact/${contact.id}`)
        .then((res) => {
          this.contacts = res.data;
          this.nguoiphutrach_enabled = true;
        })
        .catch((err) => {
            this.$toast.error(err.response.data + "", "Lỗi", { timeout: 3000 });
        });
    },

    lockNguoiPhuTrach() {
      this.nguoiphutrach_enabled = false;
      this.nguoiphutrach_selected = null;
      this.contact_infos = [];
    },

    date_different(first_date, second_date) {
      var result = 0;

      var first = this.$convert_string_date(first_date);
      var second = this.$convert_string_date(second_date);

      result = ((second - first) / 86400000) + 1;

      if (result < 0) return 0;
      return result;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
